import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import Pipe from './Pipe.js';
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../../FontKeys.js';

export default class Machine extends AContainer {
  constructor(scene, animate = true) {
    super(scene);

    this.createMachine();
    this.createSentence(animate);
  }

  createMachine() {
    this.create(250, -143, "Chain");
    this.create(-250, -143, "Chain");
    this.pipe = new Pipe(this.scene, 1);
    this.pipe2 = new Pipe(this.scene, 2);
    this.pipe3 = new Pipe(this.scene, 3);
    this.pipe4 = new Pipe(this.scene, 4);
    this.add([this.pipe, this.pipe2, this.pipe3, this.pipe4]);
    this.pipes = [this.pipe, this.pipe2, this.pipe3, this.pipe4];

    this.machine = this.create(0, -17, "machine");

    this.needle = this.scene.addImage(this.scene.mid.x, this.y - 183, "MeterNeedle");
    this.needle.setDepth(2);
    this.needle.angle = -50;
    this.glass = this.scene.addImage(this.scene.mid.x - 2, this.y - 215, "glass");
    this.glass.setDepth(2);
    this.masker = this.scene.addSquareMask(this.needle, this.scene.mid.x - 75, -270, 150, 100);
    this.masker.setDepth(2);
    this.scene.navBar?.setDepth(4);
  }

  createSentence(animate) {
    const spacer = "MMMMMMMMi";
    /** @type {string} */
    let str = gameData.sentences[0].sentence;
    let newStr = str.replace("~", spacer);
    let strInd = newStr.split(" ");

    this.sentences = [];
    let lines = 1;
    for (let i = 0; i < strInd.length; i++) {
      let txt = ABCyaPhaser.Text.addText(0, 0, 28, 0xe2d4bc, FontKeys._Tertre_Med, strInd[i], this).setResolution(1.5).setShadow(1, 1, '#222');
      this.sentences.push(txt);

      if (i === 0) {
        txt.x = -this.machine.width / 2 + txt.width / 2 + 50;
        txt.y = -12;
      } else {
        let startX = Math.round(this.sentences[i - 1].x + this.sentences[i - 1].width / 2 + txt.width / 2 + 8);
        let wordWidth = startX + txt.width / 2;
        let maxWidth = this.machine.width / 2 - 40;

        if (wordWidth >= maxWidth) {
          txt.x = -this.machine.width / 2 + txt.width / 2 + 50;
          txt.y = this.sentences[i - 1].y + 40;
          lines++;
        } else {
          txt.x = startX;
          txt.y = this.sentences[i - 1].y;
        }
      }
    }

    if(lines === 3){
      // move text up a bit to account for the 3rd line, which is rarely needed
      this.sentences.forEach(word => {
        word.y -= 20;
      });
    }

    this.emit("SENTENCE", str, lines);

    let ind = strInd.indexOf(spacer);

    this.box = this.create(this.sentences[ind].x, this.sentences[ind].y, "Round2WordTileArea").setScale(1, .9);

    if(animate) this.tweenInSentence();
  }

  changeSentence() {
    for (let i = 0; i < this.sentences.length; i++) {
      this.scene.addTween(this.sentences[i], 750, { scaleY: 0 }, Phaser.Math.Easing.Quadratic.Out);
    }

    this.scene.addTween(this.box, 750, { y: this.box.y, scaleY: 0 }, Phaser.Math.Easing.Quadratic.Out,
      () => { this.clearSentence(); });
  }

  clearSentence() {
    this.box.destroy();

    for (let i = 0; i < this.sentences.length; i++) {
      this.sentences[i].destroy();
    }

    this.createSentence();
  }

  updateMachine() {
    this.changeSentence();

    let newA = this.needle.angle + 10;
    this.scene.addTween(this.needle, 1000, { angle: newA }, Phaser.Math.Easing.Elastic.Out);
  
    for (let i = 0; i < this.pipes.length; i++) {
      this.pipes[i].updateFrequency();
    }
  }

  tweenInSentence() {
    this.box.setScale(1, 0);

    for (let i = 0; i < this.sentences.length; i++) {
      this.sentences[i].setScale(1, 0);
      this.scene.addTween(this.sentences[i], 750, { scaleY: 1 }, Phaser.Math.Easing.Quadratic.Out);
    }

    this.scene.addTween(this.box, 200, { scaleY: .9 }, Phaser.Math.Easing.Quadratic.Out);
  }

  tweenInPortal() {
    this.scene.playSound("question_machine");

    this.scene.addTween(this, 2000, { y: 310 }, Phaser.Math.Easing.Quadratic.Out);
    this.scene.addTween(this.needle, 2000, { y: 227 }, Phaser.Math.Easing.Quadratic.Out);
    this.scene.addTween(this.glass, 2000, { y: 192 }, Phaser.Math.Easing.Quadratic.Out);
    this.scene.addTween(this.masker, 2000, { y: 399 }, Phaser.Math.Easing.Quadratic.Out);
  }

  showPortal() {
    this.y = 310;
    this.needle.y = 227;
    this.glass.y = 192;
    this.masker.y = 399;
  }

  tweenOutPortal() {
    this.scene.playSound("question_machine");

    this.scene.addTween(this, 1000, { y: -100 }, Phaser.Math.Easing.Quadratic.In);
    this.scene.addTween(this.needle, 2000, { y: -1283 }, Phaser.Math.Easing.Quadratic.In);
    this.scene.addTween(this.glass, 2000, { y: -1515 }, Phaser.Math.Easing.Quadratic.In);
    this.scene.addTween(this.masker, 2000, { y: -1270 }, Phaser.Math.Easing.Quadratic.In);
  }

  cleanUp() {
    this.verbsPast = [];
    this.verbsPresent = [];
  }
}